import { NgModule, ModuleWithProviders, Type } from '@angular/core';
import { RouterModule } from '@angular/router';
import { IContextManagerConfiguration, I_CCONTEXT_MANAGER_CONFIGURATION } from './models/i-context-manager.configuration';
import { ContextManager } from './common/context-resolvers/context.manager';
import { TeamsContextResolver } from './common/context-resolvers/teams-context.resolver';
import { IMicrosoftTeamsContextAccessor } from './contract/i-microsoft-teams-context.accessor';
import { BrowserMicrosoftTeamsContextAccessor } from './browser/browser-microsoft-teams-context.accessor';
import { MicrosoftTeamsContextAcessor } from './microsoft-teams/microsoft-teams-context.accessor';
import { MicrosoftTeamsActionsExecutor } from './common/microsoft-teams-actions.executor';
import { ITeamsApplicationConfigurationProvider } from './models/i-teams-application-configuration.provider';

export function iMicrosoftTeamsContextAccessorFactory(contextResolver: TeamsContextResolver) {
  return contextResolver.isStandAlone
    ? new BrowserMicrosoftTeamsContextAccessor(contextResolver)
    : new MicrosoftTeamsContextAcessor(contextResolver);
}

@NgModule({
  providers: [
    ContextManager,
    TeamsContextResolver,
    RouterModule,
    {
      provide: IMicrosoftTeamsContextAccessor,
      useFactory: iMicrosoftTeamsContextAccessorFactory,
      deps: [TeamsContextResolver],
    },
    MicrosoftTeamsActionsExecutor,
  ],
})
export class TeamsContextModule {
  public static forRoot(
    contextManagerConfiguration: IContextManagerConfiguration,
    teamsApplicationConfigurationProviderType: Type<ITeamsApplicationConfigurationProvider>,
  ): ModuleWithProviders<TeamsContextModule> {
    return {
      ngModule: TeamsContextModule,
      providers: [
        {
          provide: I_CCONTEXT_MANAGER_CONFIGURATION,
          useValue: contextManagerConfiguration,
        },
      ],
    };
  }
}
